import * as constants from '@/common/constants';

export default {
    state: {
        sidebar: {
            opened: true
        }
    },
    mutations: {
        [constants.VUEX_MUTATIONS_SIDEBAR_TOGGLE]: state => {
            state.sidebar.opened = !state.sidebar.opened;
        }
    },
    actions: {
        [constants.VUEX_ACTIONS_SIDEBAR_TOGGLE] ({ commit }) {
            commit(constants.VUEX_MUTATIONS_SIDEBAR_TOGGLE);
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/store-app.js